import React from "react";
import { Intent, Button, Tag, Spinner } from "@blueprintjs/core";
import { Toolbar, ToolbarGroup } from "../../../../molecules/Toolbar";
import { useHistory } from "react-router-dom";
import SettingsTab from "../../SettingsTab";
import SettingsForm from "../../SettingsForm";
import FormSection from "../../../../atoms/FormSection/FormSection";
import styles from "../ShippingSettings.module.scss";
import FormInfo from "../../../../atoms/FormInfo/FormInfo";
import FormHeading from "../../../../atoms/FormHeading/FormHeading";
import SettingsBreadcrumb from "../../SettingsBreadcrumb";
import { useShippingProfile } from "./hooks";
import { CreateProfileButton } from "./CreateProfileButton";

function ShippingProfileList() {
  const history = useHistory();
  const { shippingProfiles, loading } = useShippingProfile();

  if (loading || !shippingProfiles) {
    return (
      <SettingsTab centered>
        <Spinner />
      </SettingsTab>
    );
  }

  return (
    <SettingsTab>
      <Toolbar title="Settings">
        <ToolbarGroup>
          <CreateProfileButton />
        </ToolbarGroup>
      </Toolbar>

      <SettingsForm>
        <SettingsBreadcrumb items={[{ text: "Shipping" }]} />
        <FormInfo className={styles.shippingInfo}>
          Choose where you ship and how much you charge for shipping at
          checkout. To charge different rates for certain products, create a
          shipping profile.
        </FormInfo>
        <FormSection className={styles.formSection}>
          <FormHeading rightElement={<Tag round={true}>Default</Tag>}>
            General Profile - Free Shipping
          </FormHeading>
          <FormInfo>
            All products (including variants) not in other profiles.
          </FormInfo>
        </FormSection>
        {shippingProfiles.map((profile) => (
          <FormSection key={profile.id} className={styles.formSection}>
            <FormHeading
              rightElement={
                <Button
                  minimal={true}
                  intent={Intent.PRIMARY}
                  onClick={() => {
                    history.push(`/settings/shipping/${profile.id}`);
                  }}
                >
                  Manage
                </Button>
              }
            >
              {profile.name}
            </FormHeading>
            <FormInfo>{profile.productCount} products</FormInfo>
          </FormSection>
        ))}
      </SettingsForm>
    </SettingsTab>
  );
}

export default ShippingProfileList;
